import React, { lazy, Suspense } from "react";
const er = "Entity relationship diagram";
const flowchart = "Flow chart";
const gantt = "Gantt chart";
const mermaid$1 = "Mermaid diagrams";
const pie = "Pie chart";
const sequence = "Sequence diagram";
const state = "State diagram";
const uj = "User journey diagram";
const en = {
  "class": "Class diagram",
  er,
  flowchart,
  gantt,
  mermaid: mermaid$1,
  pie,
  sequence,
  state,
  uj
};
function pluginEditorMermaid({
  locale: _locale
} = {}) {
  const locale = { ...en, ..._locale };
  const actionItems = [
    {
      title: locale.flowchart,
      code: `graph TD
Start --> Stop`
    },
    {
      title: locale.sequence,
      code: `sequenceDiagram
Alice->>John: Hello John, how are you?
John-->>Alice: Great!
Alice-)John: See you later!`
    },
    {
      title: locale.class,
      code: `classDiagram
Animal <|-- Duck
Animal <|-- Fish
Animal <|-- Zebra
Animal : +int age
Animal : +String gender
Animal: +isMammal()
Animal: +mate()
class Duck{
+String beakColor
+swim()
+quack()
}
class Fish{
-int sizeInFeet
-canEat()
}
class Zebra{
+bool is_wild
+run()
}`
    },
    {
      title: locale.state,
      code: `stateDiagram-v2
[*] --> Still
Still --> [*]

Still --> Moving
Moving --> Still
Moving --> Crash
Crash --> [*]`
    },
    {
      title: locale.er,
      code: `erDiagram
CUSTOMER ||--o{ ORDER : places
ORDER ||--|{ LINE-ITEM : contains
CUSTOMER }|..|{ DELIVERY-ADDRESS : uses`
    },
    {
      title: locale.uj,
      code: `journey
title My working day
section Go to work
Make tea: 5: Me
Go upstairs: 3: Me
Do work: 1: Me, Cat
section Go home
Go downstairs: 5: Me
Sit down: 5: Me`
    },
    {
      title: locale.gantt,
      code: `gantt
title A Gantt Diagram
dateFormat  YYYY-MM-DD
section Section
A task           :a1, 2014-01-01, 30d
Another task     :after a1  , 20d
section Another
Task in sec      :2014-01-12  , 12d
another task      : 24d`
    },
    {
      title: locale.pie,
      code: `pie title Pets adopted by volunteers
"Dogs" : 386
"Cats" : 85
"Rats" : 15`
    }
  ];
  return {
    actions: [
      {
        title: locale.mermaid,
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 48 48">
            <path stroke="currentColor" stroke-linejoin="round" stroke-width="4" d="M17 6h14v9H17zM6 33h14v9H6zM28 33h14v9H28z"></path>
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M24 16v8M13 33v-9h22v9"></path>
          </svg>
        `,
        cheatsheet: "```mermaid",
        handler: {
          type: "dropdown",
          actions: actionItems.map(({ title, code }) => ({
            title,
            handler: {
              type: "action",
              click({ editor, appendBlock, codemirror }) {
                const { line } = appendBlock("```mermaid\n" + code + "\n```");
                editor.setSelection(
                  codemirror.Pos(line + 1, 0),
                  codemirror.Pos(line + code.split("\n").length)
                );
                editor.focus();
              }
            }
          })),
          ...locale
        }
      }
    ]
  };
}
let mermaid;
let loading;
function getMermaid() {
  return new Promise((resolve, reject) => {
    if (mermaid) {
      resolve(mermaid);
    } else {
      loading != null ? loading : loading = import("mermaid").then((m) => mermaid = m);
      loading.then(resolve, reject);
    }
  });
}
function hasLoadedMermaid() {
  return mermaid;
}
const LazyMermaid = lazy(() => import("./Mermaid.590b6c04.mjs"));
function pluginViewerMermaid(LoadingElement, mermaidConfig) {
  let m;
  return {
    viewerEffect({ markdownBody }) {
      (async () => {
        const els = markdownBody.querySelectorAll(
          "pre>code.language-mermaid"
        );
        if (els.length === 0)
          return;
        if (!m) {
          m = await getMermaid().then((c) => c.default);
          if (mermaidConfig) {
            m.initialize(mermaidConfig != null ? mermaidConfig : {});
          }
        }
        els.forEach((el, i) => {
          const pre = el.parentElement;
          const source = el.innerText;
          const container = document.createElement("div");
          container.classList.add("bytemd-mermaid");
          container.style.lineHeight = "initial";
          pre.replaceWith(container);
          try {
            m.render(
              `bytemd-mermaid-${Date.now()}-${i}`,
              source,
              (svgCode) => {
                container.innerHTML = svgCode;
              },
              container
            );
          } catch (err) {
          }
        });
      })();
    },
    mdxHandlerList: ({ ctx }) => (input) => {
      if ("res" in input)
        return input;
      const node = input.source;
      if (node.type !== "code")
        return input;
      const language = node.lang || "";
      if (language !== "mermaid") {
        return input;
      }
      const code = node.value;
      return {
        res: /* @__PURE__ */ React.createElement(Suspense, { fallback: LoadingElement != null ? LoadingElement : /* @__PURE__ */ React.createElement(React.Fragment, null) }, /* @__PURE__ */ React.createElement(
          LazyMermaid,
          {
            value: code,
            mermaidConfig,
            ...ctx.calcRequireIndexProps(input)
          }
        ))
      };
    }
  };
}
export {
  pluginViewerMermaid as a,
  getMermaid as g,
  hasLoadedMermaid as h,
  pluginEditorMermaid as p
};
